/**
 * Centralised API route prefixes for the gateway.
 *
 * Every backend micro-service is reached through the gateway at:
 *   <base-url>/<SERVICE_PREFIX>/api/<VERSION>/…
 *
 * Add new services here — never hard-code prefixes in individual api files.
 */

// ── building blocks ──────────────────────────────────────────────────────────

/** Version segment shared by all services (bump when a v2 is introduced). */
const API_VERSION = 'v1';

/** Constructs a gateway prefix from a service name: `/<service>/api/<version>` */
function servicePrefix(service: string): string {
  return `/${service}/api/${API_VERSION}`;
}

// ── service prefixes ─────────────────────────────────────────────────────────

export const API_ROUTES = {
  /** tms-api-allergens — allergen & severity lookups */
  ALLERGENS: servicePrefix('allergens'),

  /** tms-api-facilities — locations, care-units, beds */
  FACILITIES: servicePrefix('facilities'),

  /** tms-api-patient — patients, assignments, milk-providers, links, documents */
  PATIENT: servicePrefix('patient'),

  /** tms-api-products — product catalogue & lookups */
  PRODUCTS: servicePrefix('products'),

  /** tms-api-milk-mgmt — milk batches, pools, pasteurisation */
  MILK_MANAGEMENT: servicePrefix('milkManagement'),

  /** tms-api-service — auth, staff, legacy endpoints */
  SERVICE: servicePrefix('service'),

  /** tms-api-onboarding — tenant onboarding */
  ONBOARDING: servicePrefix('onboarding'),

  /** tms-api-locale — localization bundles & language list */
  LOCALE: servicePrefix('locale'),

  /** tms-api-recall-master — product recall records (DynamoDB) */
  RECALL_MASTER: servicePrefix('recallMaster'),
} as const;

export type ServiceKey = keyof typeof API_ROUTES;
